import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { API_PATH_INTERNAL } from '@/lib/constants'
import serviceService from '@/lib/services/serviceService'

export function useCreateServiceMutation() {
  return useMutation({
    // retry mutation with linear backoff delay (for 4 retries the last delay is 1000 ms, total time 2.5 s)
    retry: import.meta.env.VITE_REFERRAL_MAX_RETRIES,
    retryDelay: (attempt) => attempt * 250,
    mutationFn: async ({
      serviceAreaId,
      companyId,
    }: {
      serviceAreaId: number
      companyId: number
    }) => {
      try {
        await serviceService.createService({
          company: `${API_PATH_INTERNAL}/companies/${companyId}`,
          serviceArea: `${API_PATH_INTERNAL}/service-areas/${serviceAreaId}`,
        })
      } catch (error) {
        if (error instanceof AxiosError && error.status === 422) {
          // ignore violation constrain errors - duplicate
        } else {
          throw error
        }
      }
    },
  })
}
